module.exports = __webpack_public_path__ + "img/Haarologinnen.1da7b85a.svg";